export default __webpack_public_path__ + "ade705761eb7e702770dcaa0d4ac972f.ttf";